import {Hero, Grid} from '@primer/react-brand-next'

import type {FlexSuiteDefaultHeroProps} from './types'
import {getDescription, getHeading} from './utils'

/**
 * Default hero (no variant specified): text-only gridline
 */
export function FlexSuiteHeroDefault({fields}: {fields: FlexSuiteDefaultHeroProps}) {
  const {heroHeading, heroLabel, heroDescription, heroCtaOne, heroCtaTwo, heroTertiaryDescription, options} = fields

  return (
    <Grid>
      <Grid.Column>
        <Hero
          variant={options.variant}
          trailingComponent={heroTertiaryDescription ? () => getDescription(heroTertiaryDescription) : undefined}
        >
          {heroLabel && <Hero.Label>{heroLabel}</Hero.Label>}
          <Hero.Heading>{getHeading(heroHeading)}</Hero.Heading>
          <Hero.Description>{heroDescription ? getDescription(heroDescription) : null}</Hero.Description>
          <Hero.PrimaryAction href={heroCtaOne.fields.href}>{heroCtaOne.fields.text}</Hero.PrimaryAction>
          {heroCtaTwo && (
            <Hero.SecondaryAction href={heroCtaTwo.fields.href}>{heroCtaTwo.fields.text}</Hero.SecondaryAction>
          )}
        </Hero>
      </Grid.Column>
    </Grid>
  )
}
